<template>
  <!-- 辽博讲堂 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item>
              <el-date-picker v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd">
            <svg-icon icon-class="add" />&nbsp;添加讲堂
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="title" label="讲堂标题" show-overflow-tooltip></el-table-column>
          <el-table-column prop="speaker" label="主讲人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="time" label="时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="address" label="地点" show-overflow-tooltip></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="40%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
                         layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog title="辽博讲堂" :close-on-click-modal="false" @close="onCancel" :visible.sync="dialogVisible" :width="'800px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="title">
            <el-input v-model="addForm.title" :disabled="operation == 'view'" placeholder="请输入讲堂标题" />
          </el-form-item>

          <el-form-item class="mb-30" prop="speaker">
            <el-input v-model="addForm.speaker" :disabled="operation == 'view'" placeholder="请输入主讲人" />
          </el-form-item>

          <el-form-item class="mb-30" prop="time">
            <el-date-picker v-model="addForm.time" :disabled="operation == 'view'" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
                            type="datetime" placeholder="请选择时间"></el-date-picker>
          </el-form-item>

          <el-form-item class="mb-30" prop="address">
            <el-input v-model="addForm.address" :disabled="operation == 'view'" placeholder="请输入地点" />
          </el-form-item>

          <el-form-item class="mb-30" prop="topic">
            <cmp-ckeditor ref="myCkeditor" :readOnly="operation == 'view'" :defaultMsg="addForm.topic" :id="`ue1`" :height="150"></cmp-ckeditor>
          </el-form-item>

          <el-form-item class="mb-30" prop="url">
            <el-input v-model="videoUrl" disabled placeholder="上传视频自动获取URL" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="video/*"
                       :data="configData" :show-file-list="false" :on-progress="uploadVideoProcess" :on-success="handleVideoSuccess"
                       :before-upload="beforeVideoUpload">

              <video v-if="videoUrl != '' && !videoFlag" v-bind:src="videoUrl" class="w-100" controls="controls">
                您的浏览器不支持视频播放
              </video>

              <div class="tip" v-else-if="videoUrl == '' && !videoFlag">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传讲堂视频</div>
              </div>

              <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent" style="margin-top: 7px"></el-progress>
            </el-upload>

            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="image/*"
                       :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传讲堂封面</div>
              </div>
            </el-upload>
            <div class="tip-img">建议图片大小：1600 * 900</div>

            <!-- <div class="avatar-uploader">
              <div class="uploader-form" @click="uploadPicture()">
                <img v-if="imgUrl" :src="imgUrl" alt="">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>

              <div class="tip-img">建议图片大小：244 * 196</div>
            </div> -->
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation !== 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleAvatarSuccess">
    </cropper-image>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import cmpCkeditor from '@cmp/editor/ckeditor'
import CropperImage from '@cmp/cropper'

export default {
  computed: {
    ...mapGetters(['imageTypes'])
  },
  components: { cmpCkeditor, CropperImage },

  data() {
    return {
      form: {
        title: '',
        time: ''
      },
      operation: 'add',
      addForm: {},
      rules: {
        title: [
          { required: true, message: '讲堂名称不能为空', trigger: 'blur' }
        ],
        speaker: [
          { required: true, message: '主讲人不能为空', trigger: 'blur' }
        ]
      },
      configData: {
        tableName: 'collect'
      },
      videoFlag: false,
      videoUrl: '',
      videoUploadPercent: 0,
      imgUrl: '',
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet
        .getClassroomList({
          ...this.form,
          ...this.listQuery
        })
        .then((res) => {
          this.listLoading = false
          if (res.success) {
            if (res.result && res.result.records) {
              this.tableData = res.result.records
              this.total = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //封面设置
    uploadPicture() {
      if (this.operation == 'view') {
        return
      }
      let option = {
        cropWidth: '244',
        cropHeight: '196',
        imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    // 重置查询
    resetForm() {
      this.form = {
        title: ''
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = 'view'
      this.$api.applet.getClassroomDetail({ id: obj.id }).then((res) => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.pic) {
              this.imgUrl = res.result.pic
            }
            if (res.result.url) {
              this.videoUrl = res.result.url
            }
          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = 'add'
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = 'edit'
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.pic) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.pic}`
      }

      if (obj.url) {
        this.videoUrl = `/singleMuseum/attach/getFile?fileId=${obj.url}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.applet.delClassroom({ id: obj.id }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeVideoUpload(file) {
      // var isLt2M = file.size / 1024 / 1024 < 2
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov'
        ].indexOf(file.type) == -1 //控制格式
      ) {
        this.$message.error('请上传正确的视频格式')
        return false
      }
    },

    handleVideoSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.videoFlag = false
        this.videoUploadPercent = 0
        this.videoUrl = res.result.attPath
        this.addForm.url = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },

    //进度条
    uploadVideoProcess(file, fileList) {
      this.videoFlag = true // 显示进度条
      this.videoUploadPercent = parseInt(file.percent)
      // const self = this
      // if (file.status === 'ready') {
      //   this.videoFlag = true; // 显示进度条
      //   this.videoUploadPercent = 0;
      //   const interval = setInterval(() => {
      //     if (self.videoUploadPercent >= 99) {
      //       clearInterval(interval)
      //       return
      //     }
      //     self.videoUploadPercent += 1

      //   }, 20);
      // }
      // if (file.status === 'success') {
      //   setTimeout(() => {
      //     this.videoFlag = false; // 显示进度条
      //     this.videoUploadPercent = 100;
      //   }, 500)
      // }
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.pic = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      if (!content) {
        this.$message.info('请输入主题')
        return
      } else {
        this.addForm.topic = content
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let url = 'addClassroom'
          if (this.addForm.id) {
            url = 'updateClassroom'
          }
          this.$api.applet[url](this.addForm).then((res) => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '讲堂修改成功' : '新增讲堂成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ''
                  self.getData()
                }
              })
            }
          })
        } else {
          return false
        }
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ''
      this.videoUrl = ''
      this.videoFlag = false
      this.$refs['form'].clearValidate()
      this.$refs.myCkeditor.initEditor()
    }
  },
  created() {
    this.getData()
    window.addEventListener('keyup', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      .el-form-item__content {
        display: flex;
        .avatar-uploader {
          width: 50%;
          border: 1px dashed #8c939d;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &:first-child {
            margin-right: 20px;
          }
          .el-upload {
            width: 100%;
            height: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .el-icon-plus {
            font-size: 20px;
          }

          .el-upload__text {
            line-height: 1;
          }
        }
      }
    }
  }
}
</style>